import Keycloak from "keycloak-js";

const location = window.location;

const realm = location.hostname.includes('localhost') || location.hostname.includes('abat') || location.hostname.includes('192.168') ? 'turkistan-sic' : "turkistan-sic"
const clientId = location.hostname.includes('localhost') || location.hostname.includes('abat') || location.hostname.includes('192.168') ? 'turkistan-ea' : 'turkistan-ea'

const keycloak = new Keycloak({
    url: "https://vpn.csi.kz/auth",
    realm,
    clientId,
});

export default keycloak;